import { StateType } from "@/redux";

export const selectFetchEntry = (state: StateType, key: string) =>
  state.fetchData?.[key] ?? { loading: false, error: null, data: null };
